import React, {useState} from 'react'
import {UIGameActionBoxBase, UIGameActionBoxBaseProps} from '../../UIGameActionBoxBase'
import {DiceSelector} from './DiceSelector/DiceSelector'
import {DicePair} from '@colonist/game-base-types'
import styles from './UIGameActionBoxPickDice.module.scss'

export interface UIGameActionBoxPickDiceProps extends UIGameActionBoxBaseProps {
    onDiceSelected: (dicePair: DicePair) => void
    onConfirm: () => void
}

export const UIGameActionBoxPickDice = ({
    onDiceSelected,
    onConfirm,
    isConfirmDisabled,
    isPortrait,
    ...baseProps
}: UIGameActionBoxPickDiceProps) => {
    const [selectedDice, setSelectedDice] = useState<DicePair>({dice1: 0, dice2: 0})

    const handleDiceSelected = (dicePair: Partial<DicePair>) => {
        setSelectedDice((previousSelectedDice) => {
            const newState = {
                ...previousSelectedDice,
                ...dicePair,
            }

            onDiceSelected(newState)

            return newState
        })
    }

    const areBothDiceSelected = selectedDice.dice1 !== 0 && selectedDice.dice2 !== 0
    const shouldDisableConfirm = isConfirmDisabled ? isConfirmDisabled : !areBothDiceSelected

    const handleConfirm = () => {
        if(areBothDiceSelected) onConfirm()
    }

    const bottomDiceRow = (
        <DiceSelector
            disableHover={isPortrait ?? false}
            color="white"
            onSelectDice={(diceValue) => handleDiceSelected({dice2: diceValue})}
            className={styles.diceRow}
        />
    )

    return (
        <UIGameActionBoxBase
            {...baseProps}
            footerContent={bottomDiceRow}
            isConfirmDisabled={shouldDisableConfirm}
            onConfirm={handleConfirm}
            {...(isPortrait !== undefined && {isPortrait: isPortrait})}
        >
            <DiceSelector
                disableHover={isPortrait ?? false}
                color="red"
                onSelectDice={(diceValue) => handleDiceSelected({dice1: diceValue})}
                className={styles.diceRow}
            />
        </UIGameActionBoxBase>
    )
}
